goog.provide("shadow.js.shim.module$react_use$lib$useTitle$default");
shadow.js.shim.module$react_use$lib$useTitle$default = shadow.js.shim.module$react_use$lib$useTitle.default;
